<template>
  <div class="min-h-screen bg-gray-50 p-6">
    <div class="mx-auto max-w-7xl bg-white rounded-lg shadow-sm">
      <div class="flex min-h-[800px]">
        <!-- 左侧商品列表 -->
        <div class="w-2/3 border-r border-gray-100 p-6">
  <div class="flex items-center mb-6">
    <div class="relative flex-1">
      <input
        type="text"
        placeholder="搜索商品"
        class="w-full pl-10 pr-4 py-2 border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
      />
      <i class="fas fa-search absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"></i>
    </div>
  </div>
  <div class="grid grid-cols-5 gap-4">
    <div
      v-for="(product, index) in products"
      :key="product.id" 
      :class="{'border-blue-500': selectedProducts.includes(index)}"
      class="relative border rounded-lg p-8 cursor-pointer hover:shadow-md transition-shadow"
      @click.stop="handleProductClick(index)" 
    >

    <div class="absolute left-2 top-2 z-10 flex items-center">
  <!-- 复选框容器 -->
  <div class="relative">
    <input
      type="checkbox"
      :checked="selectedProducts.includes(index)"
      @click.stop.prevent="toggleProduct(index)"
      class="opacity-0 absolute inset-0 w-full h-full cursor-pointer"
    >
    <!-- 自定义复选框 -->
    <div class="w-4 h-4 border-2 border-gray-300 rounded-sm transition-colors duration-150"></div>
    
    <!-- 集成勾选图标 -->
    <div 
      class="absolute -inset-1 flex items-center justify-center pointer-events-none"
      :class="{'opacity-0': !selectedProducts.includes(index)}"
    >
      <svg 
        class="w-5 h-5 text-blue-500 transition-opacity duration-200"
        fill="none" 
        stroke="currentColor" 
        viewBox="0 0 24 24"
      >
        <path 
          stroke-linecap="round" 
          stroke-linejoin="round" 
          stroke-width="2" 
          d="M5 13l4 4L19 7"
        />
      </svg>
    </div>
  </div>
</div>



        <!-- 上方标注 -->
        <div class="absolute -top-6 left-1 -translate-x-1/2 flex items-center">
          <i class="fas fa-arrow-right mx-2 text-gray-400"></i>
          <span class="text-gray-500 text-sm">{{ width }}cm</span>
          <i class="fas fa-arrow-left mx-2 text-gray-400"></i>
        </div>

        <!-- 左侧标注 -->
        <div class="absolute -left-6 top-1 -translate-y-1/2 flex flex-col items-center">
          <i class="fas fa-arrow-down my-2 text-gray-400"></i>
          <span class="text-gray-500 text-sm writing-mode-vertical">{{ height }}cm</span>
          <i class="fas fa-arrow-up my-2 text-gray-400"></i>
        </div>

        <!-- 图片 -->
        <div class="aspect-w-1 aspect-h-1 overflow-hidden rounded-lg">
          <img :src="product.image" :alt="product.name" class="w-full h-full object-cover" />
        </div>

        <div class="absolute -right-2 -top-2">
          <i v-if="selectedProducts.includes(index)" 
             class="fas fa-check-circle text-blue-500 text-xl"></i>
        </div>
      </div>
    </div>
  </div>

        <!-- 右侧属性配置 -->
        <div class="w-1/3 p-6">
          <div class="mb-6">
            <h2 class="text-lg font-medium mb-4">已选择 {{ selectedProducts.length }} 个商品</h2>
          </div>
          <div class="space-y-6">
            <!-- 选择产品子类型 -->
            <div class="border-b pb-6">
              <h3 class="text-sm font-medium mb-4">选择产品子类型（单选）</h3>
              <div class="flex gap-4">
                <button
                  v-for="(type,index) in productTypes"
                  :key="index"
                  :class="{
                    'bg-blue-50 text-blue-600 border-blue-200': selectedType === index,
                    'bg-gray-50 text-gray-600 border-gray-200': selectedType !== index
                  }"
                  class="px-4 py-2 border rounded-lg text-sm !rounded-button whitespace-nowrap"
                   @click="handleTypeSelect(index)"
                >
                  {{ type.name }}
                </button>
              </div>
            </div>

            <!-- 特殊工艺 -->
            <!-- <div class="border-b pb-6">
              <div class="flex items-center justify-between mb-4">
                <h3 class="text-sm font-medium">特殊工艺</h3>
                <label class="relative inline-flex items-center cursor-pointer">
                  <el-switch v-model="specialCraft"></el-switch>
                  <input type="checkbox" v-model="specialCraft" class="sr-only peer" />
                </label>
              </div>
            </div> -->

            <!-- 规格尺寸 -->
            <!-- <div>
              <h3 class="text-sm font-medium mb-4">规格尺寸</h3>
              <div class="flex items-center gap-4 mb-4">
                <div class="flex items-center">
                  <button @click="decrementWidth" class="px-2 py-1 border rounded-l !rounded-button whitespace-nowrap">
                    <i class="fas fa-minus text-gray-600"></i>
                  </button>
                  <input type="number" v-model="width" class="w-16 text-center border-y py-1 border-none" min="1" />
                  <button @click="incrementWidth" class="px-2 py-1 border rounded-r !rounded-button whitespace-nowrap">
                    <i class="fas fa-plus text-gray-600"></i>
                  </button>
                </div>
                <span class="text-gray-500">X</span>
                <div class="flex items-center">
                  <button @click="decrementHeight" class="px-2 py-1 border rounded-l !rounded-button whitespace-nowrap">
                    <i class="fas fa-minus text-gray-600"></i>
                  </button>
                  <input type="number" v-model="height" class="w-16 text-center border-y py-1 border-none" min="1" />
                  <button @click="incrementHeight" class="px-2 py-1 border rounded-r !rounded-button whitespace-nowrap">
                    <i class="fas fa-plus text-gray-600"></i>
                  </button>
                </div>
                <span class="text-gray-500">cm</span>
              </div>
            
            </div> -->


            <div class="container" v-for="(item,index) in assessList" :key="index">
    <!-- 特殊工艺开关模块 -->
    <div class="switch-container">
      <div class="info-label">
        <span>特殊工艺(线条字)</span>
        <!-- 使用原生checkbox模拟开关 -->
        <label class="switch">
          <input 
            type="checkbox" 
            :checked="item.is_special === 1"
            @change="handleSwitchChange($event, index)"
          >
          <span class="slider round"></span>
        </label>
      </div>
    </div>

    <!-- 尺寸输入区域 -->
    <div class="size-input-area">
      <!-- 特殊工艺尺寸输入 -->
      <div 
        class="input-group" 
        v-if="item.is_special === 1"
        key="special-inputs"
      >
        <input 
          class="size-input"
          type="number"
          v-model.number="item.girth"
          placeholder="周长"
        >
        <span class="multiply">×</span>
        <input 
          class="size-input"
          type="number" 
          v-model.number="item.thickness"
          placeholder="厚度"
        >
        <span class="multiply">×</span>
        <span>cm</span>
      </div>

      <!-- 常规尺寸输入 -->
      <div 
        class="input-group" 
        v-else
        key="normal-inputs"
      >
        <input 
          class="size-input"
          type="number"
          v-model.number="item.width"
          placeholder="宽"
        >
        <span class="multiply">×</span>
        <input 
          class="size-input"
          type="number" 
          v-model.number="item.height"
          placeholder="长"
        >
        <span class="multiply">×</span>
        <input 
          class="size-input"
          type="number"
          v-model.number="item.thickness"
          placeholder="厚度"
        >
      </div>

    </div>
  </div>
            <!-- 图片上传 -->
            <div
              class="border-2 border-dashed border-gray-300 rounded-lg p-4 text-center cursor-pointer hover:border-blue-500 transition-colors"
              @click="triggerUpload"
            >
              <input type="file" ref="fileInput" class="hidden" @change="handleFileUpload" accept="image/*" />
              <div v-if="!uploadedImage" class="space-y-2">
                <i class="fas fa-cloud-upload-alt text-3xl text-gray-400"></i>
                <p class="text-sm text-gray-500">点击或拖拽上传图片</p>
                <p class="text-xs text-gray-400">支持 jpg、png 格式</p>
              </div>
              <div v-else class="relative">
                <img :src="uploadedImage" alt="Uploaded image" class="max-h-40 mx-auto rounded" />
                <button
                  class="absolute top-2 right-2 bg-red-500 text-white p-1 rounded-full hover:bg-red-600 !rounded-button whitespace-nowrap"
                  @click.stop="removeImage"
                >
                  <i class="fas fa-times"></i>
                </button>
              </div>
            </div>

            <!-- 产品参数 -->
            <div class="border-b pb-6">
              <h3 class="text-sm font-medium mb-4">产品参数</h3>
              <div class="grid grid-cols-2 gap-4">
                <button
                  v-for="param in productParams"
                  :key="param.id"
                  @click="toggleParam(param.id)"
                  :class="{
                    'bg-blue-50 text-blue-600 border-blue-200': selectedParams.includes(param.id),
                    'bg-gray-50 text-gray-600 border-gray-200': !selectedParams.includes(param.id)
                  }"
                  class="px-4 py-2 border rounded-lg text-sm !rounded-button whitespace-nowrap"
                >
                  {{ param.name }}
                </button>
              </div>
            </div>

            <div class="text-sm text-gray-500 mt-4">
                注：如公式中无上述参数，不会参与计算；例如：公式没有添加厚度参数，则填写厚度也不会计算
              </div>


              <!-- 预估金额和按钮 -->
            <div class="mt-6 space-y-4">
                <div class="text-center">
                    <div v-if="estimatedPrice > 0" class="text-lg font-medium text-gray-800">
                    预估金额：<span class="text-blue-600">¥{{ estimatedPrice }}</span>
                    </div>
                </div>
                <button
                @click="handleOrder"
                class="w-full py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors !rounded-button whitespace-nowrap">
                {{ estimatedPrice > 0 ? '立即下单' : '获取估价' }}
                </button>
            </div>
       

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Hproduct from '@/api/hproduct.js'
export default {
  data() {
    return {
      uploadedImage: '',
      specialCraft: false,
      selectedParams: [],
      productParams: [],
      products: [],
      selectedProducts: [],
      productTypes: [],
      selectedType: 1,
      specialCraft: false,
      width: 1,
      height: 1,
      estimatedPrice:0,
      assessList : [],

      hindex:0,
    // 列表项索引
    index: {
      type: Number,
      required: true
    }

    };
  },
  created() {
        this.getProduct()
        },
  methods: {
    toggleParam(paramId) {
      const position = this.selectedParams.indexOf(paramId);
      if (position === -1) {
        this.selectedParams.push(paramId);
      } else {
        this.selectedParams.splice(position, 1);
      }
    },
    triggerUpload() {
      this.$refs.fileInput.click();
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.uploadedImage = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    },
    removeImage() {
      this.uploadedImage = '';
      this.$refs.fileInput.value = '';
    },

     // 切换特殊工艺状态
     handleSwitchChange(event,index) {
      // const isChecked = event.target.checked ? 1 : 0
      // this.$emit('update:special', {
      //   index: this.index,
      //   value: isChecked
      // })
      console.log('index', index)


				var hindex = this.hindex; //主产品的下标
				var sindex = this.hproduct[hindex].index; //子类型的下标

				this.hproduct[hindex].subcategerys[sindex].index = index;
				var aindex = this.hproduct[hindex].subcategerys[sindex].index; //尺寸的下标


				this.hproduct[hindex].subcategerys[sindex].assessList[aindex].is_special =
					this.hproduct[hindex].subcategerys[sindex].assessList[aindex].is_special == 0 ? 1 : 0;

    },

     // 处理商品点击（获取ID）
  handleProductClick(index) {
    console.log("选中商品ID:", index);
    // 这里添加获取商品详情的逻辑
    // 例如：
    this.hindex = index;
    this.fetchProductDetails(index);
  },
  handleTypeSelect(id){
    this.productParams = []
    this.selectedType = id
    console.log('当前选中:', this.selectedType)
    this.assessList = this.productTypes[id].assessList
    console.log("assessList",this.assessList);
    
  },
  toggleProduct(index) {
    // 强制创建新数组保证响应式
    const newSelected = [...this.selectedProducts]
    const idx = newSelected.indexOf(index) 
    if (idx > -1) {
      newSelected.splice(idx, 1)  // 移除已存在的index
    } else {
      newSelected.push(index)     // 添加新index
    }
    
    this.selectedProducts = newSelected  // 赋值新数组触发更新
    console.log("当前选中索引:", this.selectedProducts)
  },
  
    getProduct(){
      let that = this
      Hproduct.listx({},true).then((res) => {
        if(res.code == 1){
         that.products = res.data
         that.productTypes = that.products[this.hindex].subcategerys
         this.handleTypeSelect(0)
        }
      })
    },
    incrementWidth() {
      this.width++;
    },
    decrementWidth() {
      if (this.width > 1) this.width--;
    },
    incrementHeight() {
      this.height++;
    },
    decrementHeight() {
      if (this.height > 1) this.height--;
    },

handleOrder() {
  this.estimatedPrice = 22;
  return

        if (this.selectedProducts.length === 0) {
        this.estimatedPrice = 0
        return
        }
        // 计算预估价格：这里使用一个简单的计算逻辑，实际业务中可以根据需求调整
        let basePrice = this.selectedProducts.reduce((sum, index) => sum + this.products[index].price, 0)
        // 考虑尺寸因素
        const area = this.width * this.height
        basePrice = basePrice * (area / 100)
        // 考虑工艺和参数的加成
        if (this.specialCraft) basePrice *= 1.2
        basePrice += this.selectedParams.length * 50
        // 根据类型调整价格
        if (this.selectedType === 2) basePrice *= 1.2
        if (this.selectedType === 3) basePrice *= 1.5
        this.estimatedPrice = Math.round(basePrice)

  }
},
};
</script>

<style scoped>
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type="number"] {
  -moz-appearance: textfield;
}
.writing-mode-vertical {
  writing-mode: vertical-rl;
  text-orientation: mixed;
}
.custom-checkbox {
  @apply border-gray-300 bg-white;
  transition: all 0.2s ease;
}

input:checked ~ .custom-checkbox {
  @apply border-blue-500 bg-blue-500;
}

/* 勾选动画 */
.custom-checkmark {
  @apply relative w-6 h-6 pointer-events-none;
  opacity: 0;
  transform: scale(0.8);
  transition: all 0.3s cubic-bezier(0.68, -0.55, 0.27, 1.55);
}

.checked.custom-checkmark {
  opacity: 1;
  transform: scale(1);
}

/* 对勾绘制 */
.checkmark-stem {
  @apply absolute bg-blue-500;
  width: 2px;
  height: 12px;
  left: 11px;
  top: 6px;
  transform: rotate(45deg);
}

.checkmark-kick {
  @apply absolute bg-blue-500;
  width: 2px;
  height: 6px;
  left: 7px;
  top: 12px;
  transform: rotate(-45deg);
}

/* 悬停交互效果 */
.custom-checkbox:hover {
  @apply border-blue-300;
}
/* 联合动画效果 */
.relative:hover .border-gray-300 {
  border-color: #93c5fd;
}

input:checked ~ div:last-child {
  opacity: 1 !important;
}

input:checked ~ div:first-child {
  border-color: #3b82f6;
  background-color: rgba(59, 130, 246, 0.1);
}

/* 自定义入场动画 */
.absolute.-inset-1 {
  transition: opacity 0.2s cubic-bezier(0.4, 0, 0.6, 1);
}

/* 优化SVG对齐 */

input:focus ~ .custom-checkbox {
  @apply ring-2 ring-blue-200;
}

svg {
  margin-left: -2px;
  margin-top: -1px;
}
.switch {
  position: relative;
  display: inline-block;
  width: 48px;
  height: 24px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: .4s;
}

input:checked + .slider {
  background-color: #5ebaeb;
}

input:checked + .slider:before {
  transform: translateX(24px);
}

.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

/* 尺寸输入区域 */
.size-input-area {
  margin-top: 20rpx;
}

.input-group {
  display: flex;
  align-items: center;
  gap: 8px;
}

.size-input {
  width: 100px;
  padding: 6px 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.quantity-control {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 12px;
}

.control-btn {
  padding: 4px 12px;
  border: 1px solid #666;
  border-radius: 4px;
  background: none;
  cursor: pointer;
}

.formula-tip {
  font-size: 13px;
  color: #747474;
  margin-top: 12px;
}
</style>


// WEBPACK FOOTER //
// src/views/store/placeorder/index1.vue